module.exports = __webpack_public_path__ + "img/feedback-left-arrow.fd2ad876.svg";